const $ = require('jquery');
const storeLocator = require('../storelocator');
const util = require('../../utils/util');

let switchedToCollectionPoint = false;
let mapCreated = false;
const collectionPointSelected = sessionStorage.getItem('collectionPointSelected');
const collectionPointName = sessionStorage.getItem('collectionPointName');
const collectionPointID = sessionStorage.getItem('collectionPointID');
const typeDePoint = sessionStorage.getItem('typeOfPoint');
const isCollectionPointEnabled = $('.jsCollectionPointArea').length > 0;
const $searchInput = $('#dwfrm_singleshipping_collectionPoint_mapAddress');
const $countResult = $('.count-results');

/**
 * @param {boolean} value used to determine switching to or from collection point display
 */
function switchToCollectionPoint(value) {
    const $collectionPoint = $('.jsCollectionPointArea');
    const $shippingAddress = $('.jsShippingAddressArea');
    const $billingAddress = $('.jsBillingAddressArea');
    const $collectionPointForm = $('.checkout-collection-point-form');
    const $selectedCollectionPoint = $('.selected-collection-point-form');
    const $shippingphone = $('#dwfrm_singleshipping_shippingAddress_addressFields_phone');
    const $billingphone = $('#dwfrm_singleshipping_billingAddress_addressFields_phone');
    const $shippingAreaCode = $('#dwfrm_singleshipping_shippingAddress_addressFields_areaCode').parent();
    const $billingAreaCode = $('#dwfrm_singleshipping_billingAddress_addressFields_areaCode').parent();
    const $phoneExample = $billingphone.siblings('.form-caption');
    const phoneLabel = $shippingphone.siblings('.label').find('span').html();
    const areaCodeLabel = $shippingAreaCode.siblings('.label').find('span').html();
    const fieldOptionalLabel = phoneLabel.slice(phoneLabel.indexOf('(') - 1);
    const phoneLabelPlaceHolder = phoneLabel.slice(0, phoneLabel.indexOf('(') - 1).trim();
    const areaCodeLabelPlaceHolder = areaCodeLabel.slice(0, areaCodeLabel.indexOf('(') - 1).trim();
    const $useSameAddress = $('.use-same-address-row input');
    const addressAutocomplete = require('../../components/googlePlacesAutocomplete');
    addressAutocomplete.initAutocompleteForArea($billingAddress);
    $('.address-without-phone').hide();
    if (value && isCollectionPointEnabled && !switchedToCollectionPoint) {
        switchedToCollectionPoint = true;
        $collectionPoint.show();
        if (collectionPointSelected !== null) {
            const $selectedPoint = $('.selected-collection-point');
            $selectedPoint.html(collectionPointSelected);
            $('.selected-point').val(collectionPointName);
            $('.selected-point-id').val(collectionPointID);
            $('.typeOfPoint').val(typeDePoint);
            $('#dwfrm_singleshipping_shippingAddress_addressFields_city').val(
                $selectedPoint.find('.cityAddress').html()
            );
            $('#dwfrm_singleshipping_shippingAddress_addressFields_address1').val(
                $selectedPoint.find('.address1').html()
            );
            $('#dwfrm_singleshipping_shippingAddress_addressFields_address2').val(
                $selectedPoint.find('.address2').html()
            );
            $('#dwfrm_singleshipping_shippingAddress_addressFields_postal').val($selectedPoint.find('.zipCode').html());
            $('#dwfrm_singleshipping_shippingAddress_addressFields_streetNo').val('');
            $selectedCollectionPoint.show();
        } else {
            $collectionPointForm.show();
        }
        $('.collection-point-notselected-error').hide();
        $phoneExample.show();
        $useSameAddress.prop('checked', true);
        $useSameAddress.closest('span').addClass('checked');
        $shippingAddress.hide();
        $billingAddress.show();
        $billingAddress.find('#newShippingAddress').trigger('click');
        $shippingAddress.find('#newShippingAddress').trigger('click');
        $billingAddress.find('.jsAddressSelect').first().trigger('click');
        $billingphone.addClass('required');
        $billingphone.parent().addClass('required');
        $billingphone.siblings('.label').find('span').html(phoneLabelPlaceHolder);
        $billingphone.attr('placeholder', phoneLabelPlaceHolder);
        $billingAreaCode.siblings('.label').find('span').html(areaCodeLabelPlaceHolder);
        $billingAreaCode.find('.select-option').first().html(areaCodeLabelPlaceHolder);

        if ($('#collectionPoints').find('.colissimo').length > 0) {
            $billingAreaCode.find('select option[label*="+33"]').trigger('select');
            $billingAreaCode.find('select').trigger('change');
            $billingAreaCode.find('span').html($billingAreaCode.find('select option[label*="+33"]').html());
        } else if ($('#collectionPoints').find('.js-dhl24').length > 0) {
            $billingAreaCode.find('select option[label*="+48"]').trigger('select');
            $billingAreaCode.find('select').trigger('change');
            $billingAreaCode.find('span').html($billingAreaCode.find('select option[label*="+48"]').html());
        } else if ($('#collectionPoints').find('.js-bpost').length > 0) {
            $billingAreaCode.find('select option[label*="+32"]').trigger('select');
            $billingAreaCode.find('select').trigger('change');
            $billingAreaCode.find('span').html($billingAreaCode.find('select option[label*="+32"]').html());
        }

        document.activeElement.blur();

        if (!mapCreated) {
            mapCreated = true;
            storeLocator.init();
        }
        navigator.geolocation.getCurrentPosition(function success(pos) {
            const crd = pos.coords;
            $('#store-latitude').val(crd.latitude);
            $('#store-longitude').val(crd.longitude);
            const latLng = new window.google.maps.LatLng(crd.latitude, crd.longitude);
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({location: latLng}).then(response => {
                if (response.results[0]) {
                    let geolocationAddress = response.results[0].formatted_address;
                    if (geolocationAddress) {
                        if (geolocationAddress.split(',').length > 2) {
                            geolocationAddress = geolocationAddress.split(',');
                            geolocationAddress.pop();
                            geolocationAddress.join(',');
                        }
                        $collectionPointForm
                            .find('#dwfrm_singleshipping_collectionPoint_collectionAddress')
                            .val(geolocationAddress)
                            .trigger('input');
                        storeLocator.panMap(latLng);
                    }
                }
            });
        });
    } else if (!value && isCollectionPointEnabled && switchedToCollectionPoint) {
        $('.selected-point').val('');
        switchedToCollectionPoint = false;
        $billingAreaCode.find('select').prop('disabled', false);
        $phoneExample.hide();
        $collectionPoint.hide();
        $collectionPointForm.hide();
        $selectedCollectionPoint.hide();
        $shippingAddress.show();
        $shippingAddress.find('.jsAddressSelect').first().trigger('click');
        $useSameAddress.prop('checked', false);
        $useSameAddress.closest('span').removeClass('checked');
        $billingAddress.hide();
        $billingphone.removeClass('required');
        $billingphone.parent().removeClass('required');
        $billingphone
            .parent()
            .find('.label')
            .find('span')
            .html(phoneLabelPlaceHolder + fieldOptionalLabel);
        $billingphone.attr('placeholder', phoneLabelPlaceHolder + fieldOptionalLabel);
        $billingAreaCode
            .parent()
            .find('.label')
            .find('span')
            .html(areaCodeLabelPlaceHolder + fieldOptionalLabel);
        $billingAreaCode
            .find('.select-option')
            .first()
            .html(areaCodeLabelPlaceHolder + fieldOptionalLabel);
        $billingAreaCode.find('select').trigger('select');
        $billingphone.trigger('focus');
        document.activeElement.blur();
    }
}

if (isCollectionPointEnabled) {
    $('.collection-point-find').on('click', function () {
        const $input = $('#dwfrm_singleshipping_collectionPoint_collectionAddress');
        const $mapInput = $('#dwfrm_singleshipping_collectionPoint_mapAddress');
        const $map = $('.jsCollectionPointMap');
        if (this.id === 'collection-point-find') {
            $input.trigger('blur');
            if ($input.val().match(/.+,.+/)) {
                $('.header-wrapper').hide();
                $map.show();
                $mapInput.val($input.val());
                $('.store-btn-search').trigger('click');
                $mapInput.siblings('.label').remove();
            }
        } else {
            $('.header-wrapper').hide();
            $map.show();
        }
    });

    $('body').on(
        'click',
        '.jsCollectionPointMap, .collection-point-header .close, .select-collection-point',
        function (e) {
            const $collectionPointForm = $('.checkout-collection-point-form');
            const $selectedCollectionPoint = $('.selected-collection-point-form');
            const $target = $(e.target);
            // checking against e.target === this so that the overlay only closes when clicking outside (main element), and not to close on clicking child elements.
            if (e.target === this) {
                $('.header-wrapper').show();
                $('.jsCollectionPointMap').hide();
            }
            if ($target.hasClass('select-collection-point')) {
                const content = $target.closest('.marker-content');
                const name = content.find('.name').clone();
                const address2 = content.find('.address2').clone();
                const address1 = content.find('.address1').clone();
                const city = content.find('.city').clone();
                const openTimes = content.find('.store-hours').html().replace(/li>/gi, 'p>');
                const pointID = content.find('.store-hours').attr('data-pointid').trim();
                const zipCode = content.find('.postalCode').attr('data-postalcode').trim();
                const typeOfPoint = content.find('.typeDePoint').html();
                const $displayedText = $('.selected-collection-point');
                const cityAddress = city.html().replace(zipCode, '');
                $displayedText.html('');
                $displayedText.append(name);
                $displayedText.append(address2);
                $displayedText.append(address1);
                $displayedText.append(
                    `<p class="city"><span class="cityAddress">${cityAddress}</span><span class="zipCode">${zipCode}</span></p>`
                );
                $displayedText.append(`<div class="store-hours selected">${openTimes}</div>`);
                $('.selected-point').val(name.html());
                $('.selected-point-id').val(pointID);
                $('.typeOfPoint').val(typeOfPoint);
                $('#dwfrm_singleshipping_shippingAddress_addressFields_city').val(cityAddress.trim());
                $('#dwfrm_singleshipping_shippingAddress_addressFields_address1').val(address1.html());
                $('#dwfrm_singleshipping_shippingAddress_addressFields_address2').val(address2.html());
                $('#dwfrm_singleshipping_shippingAddress_addressFields_postal').val(zipCode);
                $('#dwfrm_singleshipping_shippingAddress_addressFields_streetNo').val('');
                $('.collection-point-notselected-error').hide();
                $collectionPointForm.hide();
                $selectedCollectionPoint.show();
                sessionStorage.setItem('collectionPointSelected', $displayedText.html());
                sessionStorage.setItem('collectionPointID', pointID);
                sessionStorage.setItem('collectionPointName', name.html());
                sessionStorage.setItem('typeOfPoint', typeOfPoint);
            }
        }
    );
}

/**
 * Show Collection Points for Colissimo Lapostepudo
 *
 * @returns {void}
 */
function showColissimoPoints() {
    if ($searchInput && $searchInput.val()) {
        const country = $('#store-country').val();
        const shippingDate = new Date().toLocaleDateString('en-GB');
        const searchText = $searchInput.val().replace(/ /g, '%20').split(',');
        if (searchText.length === 2) {
            const regionNames = new Intl.DisplayNames(['en'], {type: 'region'});
            searchText.push(regionNames.of(country));
        }
        let zipCode;
        if (searchText[2]) {
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({address: $searchInput.val()}, function (results, status) {
                if (results && status === window.google.maps.GeocoderStatus.OK) {
                    for (let current = 0; current < results[0].address_components.length; current++) {
                        if (results[0].address_components[current].types[0] === 'postal_code') {
                            zipCode = results[0].address_components[current].long_name;
                            break;
                        }
                    }
                    const url = util.appendParamsToUrl(Urls.getColissimoPoints, {
                        shippingDate,
                        zipCode,
                        countryCode: country,
                        address: searchText[0],
                        city: searchText[1]
                    });
                    $.ajax({
                        type: 'GET',
                        url,
                        /**
                         * @param {string} result search result for collection points on map
                         */
                        success(result) {
                            const parser = new DOMParser();
                            const res = parser.parseFromString(result, 'text/xml');
                            const points = {};
                            $(res.firstElementChild)
                                .find('listePointRetraitAcheminement')
                                .each(function (i) {
                                    const pointInfo = {};
                                    const point = {};
                                    $(this)
                                        .children()
                                        .each(function () {
                                            const current = $(this);
                                            if (current.prop('tagName').includes('horairesOuverture')) {
                                                pointInfo[current.prop('tagName')] = current
                                                    .html()
                                                    .replace('00:00-00:00', '')
                                                    .replace(' 00:00-00:00', Resources.CLOSED);
                                            } else {
                                                pointInfo[current.prop('tagName')] = current.html();
                                            }
                                        });
                                    point.name = pointInfo.nom;
                                    point.address1 = pointInfo.adresse1;
                                    point.address2 = pointInfo.adresse2;
                                    point.city = pointInfo.localite;
                                    point.latitude = Number(pointInfo.coordGeolocalisationLatitude);
                                    point.longitude = Number(pointInfo.coordGeolocalisationLongitude);
                                    point.phone = '';
                                    point.phoneAreaCode = '';
                                    point.email = null;
                                    point.id = pointInfo.identifiant;
                                    point.state = null;
                                    point.postalCode = pointInfo.codePostal;
                                    point.countryCode = pointInfo.codePays;
                                    point.storeType = 1;
                                    point.distanceToRefRaw = Number(pointInfo.distanceEnMetre) / 1000;
                                    point.distance = `${point.distanceToRefRaw.toFixed(2)}`;
                                    point.distanceToRef = point.distance;
                                    point.distanceUnit = 'km';
                                    point.storeHoursHTML = `<br><ul><li>${Resources.MONDAY}</li><li>${
                                        Resources.TUESDAY
                                    }</li><li>${Resources.WEDNESDAY}</li><li>${Resources.THURSDAY}</li><li>${
                                        Resources.FRIDAY
                                    }</li><li>${Resources.SATURDAY}</li><li>${Resources.SUNDAY}</li></ul><ul><li>${
                                        pointInfo.horairesOuvertureLundi || 'unknown'
                                    }</li><li>${pointInfo.horairesOuvertureMardi || 'unknown'}</li><li>${
                                        pointInfo.horairesOuvertureMercredi || 'unknown'
                                    }</li><li>${pointInfo.horairesOuvertureJeudi || 'unknown'}</li><li>${
                                        pointInfo.horairesOuvertureVendredi || 'unknown'
                                    }</li><li>${pointInfo.horairesOuvertureSamedi || 'unknown'}</li><li>${
                                        pointInfo.horairesOuvertureDimanche || 'unknown'
                                    }</li></ul>`;
                                    point.storeEventsHTML = `<span>${Resources.NOEVENT}</span>`;
                                    point.storeDetailsFlyinLink = '';
                                    point.storeLocatorType = 'collectionpoint';
                                    point.parking = pointInfo.parking;
                                    point.openFrom = pointInfo.periodeActiviteHoraireDeb;
                                    point.openTill = pointInfo.periodeActiviteHoraireFin;
                                    point.typeDePoint = pointInfo.typeDePoint;
                                    points[i] = point;
                                });
                            const keys = Object.keys(points);
                            storeLocator.showStoresOnMap(points);
                            storeLocator.showStoresOnSearchList(points);
                            if (keys.length === 0) {
                                $countResult.html(Resources.NO_POINTS_FOUND).show();
                            } else {
                                $countResult.html('').hide();
                            }
                        }
                    });
                }
            });
        }
    }
}

/**
 * Transform Data from DHL to Storelocator points
 *
 * @param {Array} pointsInfo - array of dhl service points
 * @returns {Array} - array in the format of Storelocator
 */
function _transformDataDHLtoStorelocator(pointsInfo) {
    let stores = [];
    if (pointsInfo) {
        stores = pointsInfo.map(store => {
            store.address1 = `${store.houseNumber.replace(/\s+/g, '')} ${store.street}`;
            store.address2 = '';
            store.phone = '';
            store.phoneAreaCode = '';
            store.email = null;
            store.id = store.sap;
            store.state = null;
            store.postalCode = store.postCode;
            store.storeType = 1;
            store.distanceToRef = store.distance.toFixed(3);
            store.distanceUnit = 'km';
            store.storeHoursHTML = `<br>
                <ul>
                    <li>${Resources.MONDAY}</li>
                    <li>${Resources.TUESDAY}</li>
                    <li>${Resources.WEDNESDAY}</li>
                    <li>${Resources.THURSDAY}</li>
                    <li>${Resources.FRIDAY}</li>
                    <li>${Resources.SATURDAY}</li>
                    <li>${Resources.SUNDAY}</li>
                </ul>
                <ul>
                    <li>${store.MONDAY || Resources.CLOSED}</li>
                    <li>${store.TUESDAY || Resources.CLOSED}</li>
                    <li>${store.WEDNESDAY || Resources.CLOSED}</li>
                    <li>${store.THURSDAY || Resources.CLOSED}</li>
                    <li>${store.FRIDAY || Resources.CLOSED}</li>
                    <li>${store.SATURDAY || Resources.CLOSED}</li>
                    <li>${store.SUNDAY || Resources.CLOSED}</li>
                </ul>`;
            store.storeEventsHTML = `<span>${Resources.NOEVENT}</span>`;
            store.storeDetailsFlyinLink = '';
            store.storeLocatorType = 'collectionpoint';
            return store;
        });
    }
    return stores;
}

/**
 * Show Service Points for DHL24
 *
 * @returns {void}
 */
function showServicePoints() {
    if ($searchInput && $searchInput.val()) {
        const searchText = $searchInput.val().replace(/ /g, '%20').split(',');
        let zipCode;
        let location;
        if (searchText[2]) {
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({address: $searchInput.val()}, function (results, status) {
                if (results && status === window.google.maps.GeocoderStatus.OK) {
                    for (let current = 0; current < results[0].address_components.length; current++) {
                        if (results[0].address_components[current].types[0] === 'postal_code') {
                            zipCode = results[0].address_components[current].long_name;
                            location = {
                                lat: results[0].geometry.location.lat(),
                                lng: results[0].geometry.location.lng()
                            };
                            break;
                        }
                    }

                    const url = util.appendParamsToUrl(Urls.getDHL24Points, {
                        zipCode,
                        city: searchText[1].trim(),
                        lat: location.lat,
                        lng: location.lng
                    });

                    $.ajax({
                        type: 'GET',
                        url,
                        cache: true,
                        /**
                         * @param {string} result search result for collection points on map
                         */
                        success(result) {
                            if (result && result.error) {
                                $countResult.html(Resources.SERVICE_ERROR).show();
                            } else {
                                let points = util.parseJSON(result);
                                points = _transformDataDHLtoStorelocator(points);
                                const keys = Object.keys(points);
                                storeLocator.showStoresOnMap(points);
                                storeLocator.showStoresOnSearchList(points);
                                if (keys.length === 0) {
                                    $countResult.html(Resources.NO_POINTS_FOUND).show();
                                } else {
                                    $countResult.html('').hide();
                                }
                            }
                        }
                    });
                }
            });
        }
    }
}

/**
 * Transform Data from BPost to Storelocator points
 *
 * @param {Array} pointsInfo - xml with BPost service points
 * @returns {Array} - array in the format of Storelocator
 */
function _transformBPostDataToStorelocator(pointsInfo) {
    const parser = new DOMParser();
    const res = parser.parseFromString(pointsInfo, 'text/xml');
    const errorNode = res.querySelector('parsererror');
    const points = {};
    if (pointsInfo && !errorNode) {
        $(res.firstElementChild)
            .find('Poi')
            .each(function (i) {
                const pointInfo = {};
                const point = {};
                $(this)
                    .children()
                    .each(function () {
                        const current = $(this);
                        if (current.prop('tagName').includes('Distance')) {
                            pointInfo[current.prop('tagName')] = current.html();
                        }
                    });

                $(this)
                    .find('Record')
                    .children()
                    .each(function () {
                        const currentRecord = $(this);
                        if (!currentRecord.prop('tagName').includes('Hours')) {
                            pointInfo[currentRecord.prop('tagName')] = currentRecord.html();
                        }
                    });

                point.name = pointInfo.Name;
                point.address1 = `${pointInfo.Number.replace(/\s+/g, '')} ${pointInfo.Street}`;
                point.address2 = '';
                point.city = pointInfo.City;
                point.latitude = Number(pointInfo.Latitude);
                point.longitude = Number(pointInfo.Longitude);
                point.phone = '';
                point.phoneAreaCode = '';
                point.email = null;
                point.id = pointInfo.Id;
                point.state = null;
                point.postalCode = pointInfo.Zip;
                point.countryCode = pointInfo.Country;
                point.storeType = 1;
                point.distanceToRefRaw = Number(pointInfo.Distance) / 1000;
                point.distance = `${point.distanceToRefRaw.toFixed(3)}`;
                point.distanceToRef = point.distance;
                point.distanceUnit = 'km';
                point.storeEventsHTML = `<span>${Resources.NOEVENT}</span>`;
                point.storeDetailsFlyinLink = '';
                point.storeLocatorType = 'collectionpoint';
                point.typeDePoint = pointInfo.Type;

                $(this)
                    .find('Hours')
                    .children()
                    .each(function () {
                        let workingHours = '';
                        const currentHours = $(this);
                        const workFromTo = currentHours.children();
                        const startAM = workFromTo[0]?.textContent;
                        const stopAM = workFromTo[1]?.textContent;
                        const startPM = workFromTo[2]?.textContent;
                        const stopPM = workFromTo[3]?.textContent;
                        if (startAM && stopAM) {
                            workingHours = `${startAM}-${stopAM}`;
                            pointInfo.openFrom = startAM;
                            pointInfo.openTill = stopAM;
                        }
                        if (startAM && stopAM && startPM && stopPM) {
                            workingHours = `${startAM}-${stopAM} ${startPM}-${stopPM}`;
                            pointInfo.openFrom = startAM;
                            pointInfo.openTill = stopPM;
                        }
                        pointInfo[currentHours.prop('tagName')] = workingHours;
                    });

                point.storeHoursHTML = `<br>
                    <ul>
                        <li>${Resources.MONDAY}</li>
                        <li>${Resources.TUESDAY}</li>
                        <li>${Resources.WEDNESDAY}</li>
                        <li>${Resources.THURSDAY}</li>
                        <li>${Resources.FRIDAY}</li>
                        <li>${Resources.SATURDAY}</li>
                        <li>${Resources.SUNDAY}</li>
                    </ul>
                    <ul>
                        <li>${pointInfo.Monday || Resources.CLOSED}</li>
                        <li>${pointInfo.Tuesday || Resources.CLOSED}</li>
                        <li>${pointInfo.Wednesday || Resources.CLOSED}</li>
                        <li>${pointInfo.Thursday || Resources.CLOSED}</li>
                        <li>${pointInfo.Friday || Resources.CLOSED}</li>
                        <li>${pointInfo.Saturday || Resources.CLOSED}</li>
                        <li>${pointInfo.Sunday || Resources.CLOSED}</li>
                    </ul>`;
                point.openFrom = pointInfo.openFrom;
                point.openTill = pointInfo.openTill;

                points[i] = point;
            });
    }
    return points;
}

/**
 * Show Collection Points for Bpost
 *
 * @returns {void}
 */
function showBpostPoints() {
    if ($searchInput && $searchInput.val()) {
        const searchText = $searchInput.val().replace(/ /g, '%20').split(',');
        let postalCode = '';
        let street = '';
        let streetNumber = '';
        if (searchText[1]) {
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({address: $searchInput.val()}, function (results, status) {
                if (results && status === window.google.maps.GeocoderStatus.OK) {
                    for (let current = 0; current < results[0].address_components.length; current++) {
                        if (results[0].address_components[current].types[0] === 'postal_code') {
                            postalCode = results[0].address_components[current].long_name;
                        } else if (results[0].address_components[current].types[0] === 'street_number') {
                            streetNumber = results[0].address_components[current].long_name;
                        } else if (results[0].address_components[current].types[0] === 'route') {
                            street = results[0].address_components[current].long_name;
                        }
                    }

                    const url = util.appendParamsToUrl(Urls.getBpostPoints, {
                        postalCode,
                        street,
                        streetNumber
                    });

                    $.ajax({
                        type: 'GET',
                        url,
                        cache: true,
                        /**
                         * @param {string} result search result for collection points on map
                         */
                        success(result) {
                            if (result && result.error) {
                                $countResult.html(Resources.SERVICE_ERROR).show();
                            } else {
                                const points = _transformBPostDataToStorelocator(result);
                                const keys = Object.keys(points);
                                storeLocator.showStoresOnMap(points);
                                storeLocator.showStoresOnSearchList(points);
                                if (keys.length === 0) {
                                    $countResult.html(Resources.NO_POINTS_FOUND).show();
                                } else {
                                    $countResult.html('').hide();
                                }
                            }
                        }
                    });
                }
            });
        }
    }
}

/**
 * @param {Object} savedAddress - saved address
 */
function updateFormFromSavedAddress(savedAddress) {
    $('#dwfrm_singleshipping_billingAddress_addressFields_salutation').val(savedAddress.salutation);
    $('#dwfrm_singleshipping_billingAddress_addressFields_city').val(savedAddress.city);
    $('#dwfrm_singleshipping_billingAddress_addressFields_address1').val(savedAddress.address1);
    $('#dwfrm_singleshipping_billingAddress_addressFields_address2').val(savedAddress.address2);
    $('#dwfrm_singleshipping_billingAddress_addressFields_postal').val(savedAddress.postal);
    $('#dwfrm_singleshipping_billingAddress_addressFields_firstName').val(savedAddress.firstName);
    $('#dwfrm_singleshipping_billingAddress_addressFields_lastName').val(savedAddress.lastName);
    $('#dwfrm_singleshipping_billingAddress_addressFields_streetNo').val(savedAddress.streetNo);
    $('#dwfrm_singleshipping_billingAddress_addressFields_country').val(savedAddress.country);
    $('#dwfrm_singleshipping_billingAddress_addressFields_phone').val(savedAddress.phone);
    $('#dwfrm_singleshipping_billingAddress_addressFields_areaCode').val(savedAddress.areaCode);
    $('#dwfrm_singleshipping_billingAddress_addressFields_salutation').trigger('click');
    $('#dwfrm_singleshipping_billingAddress_addressFields_areaCode').trigger('click');
    $('#dwfrm_singleshipping_billingAddress_addressFields_country').trigger('click');
    $('#dwfrm_singleshipping_billingAddress_addressFields_phone').trigger('blur');
    $('#dwfrm_singleshipping_billingAddress_addToAddressBook').trigger('click');
    $('.address-without-phone').show();
}

exports.updateFormFromSavedAddress = updateFormFromSavedAddress;
exports.switchToCollectionPoint = switchToCollectionPoint;
exports.showColissimoPoints = showColissimoPoints;
exports.showServicePoints = showServicePoints;
exports.showBpostPoints = showBpostPoints;
